"use client";

import React from "react";

import {
  ResultsNextArrow,
  ResultsPrevArrow,
} from "@/components/common/ResultsSliderBase/ResultsArrows";
import { useResultsContext } from "@/components/common/ResultsSliderBase/ResultsContext";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";

type ResultsCounterProps = {
  className?: string;
};

export function ResultsCounter({ className }: ResultsCounterProps) {
  const { activeIndex, slidesCount } = useResultsContext();

  return (
    <div
      className={cn(
        "flex w-full mx-auto justify-between md:justify-center items-center",
        className
      )}
    >
      <div className="pr-2">
        <ResultsPrevArrow />
      </div>
      <div className="flex flex-1 justify-center items-center h-full">
        <TextElementNova
          element="p"
          text={`${activeIndex + 1} / ${slidesCount}`}
          className="Body-10-Dia-Normal"
        />
      </div>
      <div className="pl-2">
        <ResultsNextArrow />
      </div>
    </div>
  );
}
